import { Language } from '@common/enums/global.enums'
import de from './messages.de'
import en from './messages.en'
import es from './messages.es'
import fr from './messages.fr'
import it from './messages.it'

export const messages = {
	[Language.EN]: en,
	[Language.DE]: de,
	[Language.ES]: es,
	[Language.FR]: fr,
	[Language.IT]: it
}